import * as React from "react";
import { FaChevronLeft } from "react-icons/fa";
import styled from "styled-components";

export const ArrowContainer = styled.div`
  height: 3rem;
  width: 3rem;
  background-color: ${({ theme }) => theme.colors.menuBlueLight};
  position: fixed;
  top: 11.5rem;
  z-index: 6;
  border-radius: 3rem;
  display: grid;
  place-items: center;
  left: 28.5rem;
  transform: rotate(0deg);
  transition: transform 500ms, left 500ms;
  color: ${({ theme }) => theme.colors.white};
  box-shadow: 0 0.3rem 0.1rem -0.2rem rgb(0 0 0 / 20%), 0 0.2rem 0.2rem 0 rgb(0 0 0 / 14%),
    0 0.1rem 0.5rem 0 rgb(0 0 0 / 12%);

  :hover {
    background: ${({ theme }) => theme.colors.menuBlueSolidDark};
    cursor: pointer;
  }
  &.override {
    left: 4.1rem;
    transform: rotate(180deg);
    transition: left 500ms, transform 500ms;
  }
  @media (max-width: 800px) {
    display: none;
  }
`;

export interface ISideMenuArrow {
  isOpen: boolean;
  toggleOpen?: () => void;
}
export const SideMenuArrowContext = React.createContext<ISideMenuArrow>({
  isOpen: true,
});
export const SideMenuCloseArrow = () => {
  const { isOpen, toggleOpen } = React.useContext(SideMenuArrowContext);
  return (
    <ArrowContainer data-testid="arrowButton" className={isOpen ? "" : "override"} onClick={toggleOpen}>
      <FaChevronLeft />
    </ArrowContainer>
  );
};
